<template>
  <h2 class="text-xl font-serif text-gray-800 tracking-wide mb-2 font-ivymode font-minerva">
    <slot/>
  </h2>
</template>

<script setup lang="ts">
</script>

<style scoped>
</style>
